export enum FormControlsListBlock {
  Root = 'FormControlsList',
}

export enum FormControlsListModifier {
  Inline = 'inline',
}
